import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
	components: {}
})
export default class PageTitle extends Vue {
	@Prop({ default: "" }) title?: string;
}
